export interface Category {
  slug: string;
  url: string;
  seq: string;
  image: string;
}

export const categories: Category[] = [
  {
    slug: "shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    seq: "cat-01",
    image:
      "https://readdy.ai/api/search-image?query=White%20and%20green%20modern%20sneakers%20on%20a%20soft%20sage%20green%20pastel%20studio%20background%2C%20minimalist%20product%20photography%2C%20soft%20natural%20lighting%2C%20fresh%20clean%20editorial%20style%2C%20high%20detail&width=600&height=600&seq=cat-01&orientation=squarish&nocache=true",
  },
  {
    slug: "hoodies",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    seq: "cat-02",
    image:
      "https://readdy.ai/api/search-image?query=Grey%20casual%20hoodie%20sweatshirt%20on%20a%20warm%20peach%20pastel%20background%2C%20minimalist%20product%20photography%2C%20soft%20natural%20light%2C%20clean%20fresh%20editorial%20style%2C%20high%20detail&width=600&height=600&seq=cat-02&orientation=squarish&nocache=true",
  },
  {
    slug: "tshirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    seq: "cat-03",
    image:
      "https://readdy.ai/api/search-image?query=Neatly%20folded%20plain%20t-shirt%20on%20a%20soft%20mint%20green%20pastel%20background%2C%20minimalist%20product%20photography%2C%20soft%20natural%20light%2C%20clean%20fresh%20editorial%20style%2C%20high%20detail&width=600&height=600&seq=cat-03&orientation=squarish&nocache=true",
  },
  {
    slug: "jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    seq: "cat-04",
    image:
      "https://readdy.ai/api/search-image?query=Modern%20denim%20jacket%20on%20a%20warm%20sand%20tan%20background%2C%20minimalist%20product%20photography%2C%20soft%20natural%20light%2C%20clean%20fresh%20editorial%20style%2C%20high%20detail&width=600&height=600&seq=cat-04&orientation=squarish&nocache=true",
  },
  {
    slug: "pants",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    seq: "cat-05",
    image:
      "https://readdy.ai/api/search-image?query=Neatly%20folded%20casual%20trousers%20on%20a%20soft%20blush%20pink%20background%2C%20minimalist%20product%20photography%2C%20soft%20natural%20light%2C%20clean%20fresh%20editorial%20style%2C%20high%20detail&width=600&height=600&seq=cat-05&orientation=squarish&nocache=true",
  },
  {
    slug: "headwear",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    seq: "cat-06",
    image:
      "https://readdy.ai/api/search-image?query=Stylish%20baseball%20cap%20on%20a%20soft%20lemon%20yellow%20background%2C%20minimalist%20product%20photography%2C%20soft%20natural%20light%2C%20clean%20fresh%20editorial%20style%2C%20high%20detail&width=600&height=600&seq=cat-06&orientation=squarish&nocache=true",
  },
  {
    slug: "sets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    seq: "cat-07",
    image:
      "https://readdy.ai/api/search-image?query=Matching%20coordinated%20outfit%20set%20flat%20lay%20on%20a%20soft%20coral%20background%2C%20minimalist%20product%20photography%2C%20soft%20natural%20light%2C%20clean%20fresh%20editorial%20style%2C%20high%20detail&width=600&height=600&seq=cat-07&orientation=squarish&nocache=true",
  },
  {
    slug: "underwear",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    seq: "cat-08",
    image:
      "https://readdy.ai/api/search-image?query=Soft%20cotton%20underwear%20neatly%20arranged%20on%20a%20warm%20grey%20background%2C%20minimalist%20product%20photography%2C%20soft%20natural%20light%2C%20clean%20fresh%20editorial%20style%2C%20high%20detail&width=600&height=600&seq=cat-08&orientation=squarish&nocache=true",
  },
  {
    slug: "jersey",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    seq: "cat-09",
    image:
      "https://readdy.ai/api/search-image?query=Sports%20jersey%20folded%20on%20a%20fresh%20grass%20green%20background%2C%20minimalist%20product%20photography%2C%20soft%20natural%20light%2C%20clean%20fresh%20editorial%20style%2C%20high%20detail&width=600&height=600&seq=cat-09&orientation=squarish&nocache=true",
  },
  {
    slug: "accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    seq: "cat-10",
    image:
      "https://readdy.ai/api/search-image?query=Sunglasses%20and%20wristwatch%20on%20a%20soft%20terracotta%20background%2C%20minimalist%20product%20photography%2C%20soft%20natural%20light%2C%20clean%20fresh%20editorial%20style%2C%20high%20detail&width=600&height=600&seq=cat-10&orientation=squarish&nocache=true",
  },
  {
    slug: "bags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    seq: "cat-11",
    image:
      "https://readdy.ai/api/search-image?query=Leather%20tote%20bag%20on%20a%20soft%20teal%20background%2C%20minimalist%20product%20photography%2C%20soft%20natural%20light%2C%20clean%20fresh%20editorial%20style%2C%20high%20detail&width=600&height=600&seq=cat-11&orientation=squarish&nocache=true",
  },
  {
    slug: "belts",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    seq: "cat-12",
    image:
      "https://readdy.ai/api/search-image?query=Leather%20belt%20coiled%20on%20a%20warm%20chocolate%20brown%20background%2C%20minimalist%20product%20photography%2C%20soft%20natural%20light%2C%20clean%20fresh%20editorial%20style%2C%20high%20detail&width=600&height=600&seq=cat-12&orientation=squarish&nocache=true",
  },
  {
    slug: "perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    seq: "cat-13",
    image:
      "https://readdy.ai/api/search-image?query=Elegant%20glass%20perfume%20bottle%20on%20a%20soft%20amber%20gold%20background%2C%20minimalist%20product%20photography%2C%20soft%20natural%20light%2C%20clean%20fresh%20editorial%20style%2C%20high%20detail&width=600&height=600&seq=cat-13&orientation=squarish&nocache=true",
  },
  {
    slug: "other",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    seq: "cat-14",
    image:
      "https://readdy.ai/api/search-image?query=Assorted%20fashion%20accessories%20on%20a%20warm%20cream%20background%20with%20coral%20accents%2C%20minimalist%20product%20photography%2C%20soft%20natural%20light%2C%20clean%20fresh%20editorial%20style%2C%20high%20detail&width=600&height=600&seq=cat-14&orientation=squarish&nocache=true",
  },
];

export const MAIN_SITE_URL = "https://kaspreadsheet.com";